module.exports = __webpack_public_path__ + "static/media/Confetti-Doodles.072cdf9d.svg";